import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import EditDemandTableContainer                 from '../Table/EditDemandTableContainer';

function PxoEditDemandModal ({
    isOpen, 
    onClose, 
    demandPostData,     
    newValues, 
    setNewValues,    
    isSaving,
    onUpdateNewValues,
    errorMessage
}){

    return(

        <Dialog open={isOpen} onClose={onClose} className={'relative z-[100]'}>
        
        <DialogBackdrop onClick={onClose} transition className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"/>
        
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    
                    <DialogPanel transition className="max-h-[70%] w-[606px] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">   
                        
                        <div className="app-container">
                            
                            <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                                
                                <h2     className="text-white text-[1rem] leading-7 font-semibold">Editar Demanda</h2>
                                <button className="text-[1.2rem] text-white hover:text-gray-200 pr-2" onClick={onClose}>×</button>
                                
                            </header>
    
                            <div className='min-h-[250px] overflow-y-auto overflow-x-hidden' style={{padding: '1.5rem'}}>

                                <EditDemandTableContainer 
                                    demandPostData={demandPostData}
                                    newValues={newValues}
                                    setNewValues={setNewValues}
                                />

                                {errorMessage && (
                                    <p className="text-red-600 text-sm mt-3 text-left" role="alert">
                                        {errorMessage}
                                    </p>
                                )}
                                
                            </div>

                            <div className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                
                                <button 
                                    className="btn btn-azul-prof w-full" 
                                    onClick={onUpdateNewValues}
                                    disabled={newValues.length === 0 || isSaving}
                                >
                                    {isSaving ? 'Salvando...' : 'Salvar'}
                                </button>

                            </div>
                            
                        </div>
    
                    </DialogPanel>
                
                </div>

            </div>

        </Dialog>

    )
}

export default PxoEditDemandModal